<template lang="pug">
section.visible__layout
  h1.h1-title {{$t('common.myProfile')}}

  spacer(size="40px")

  .tab-controls
    router-link.tab-controls__item(to="/profile/info")
      span.tab-controls__item__title {{ $t('mainInfo') }}
      span.tab-controls__item__anchor
    router-link.tab-controls__item(v-if="isAfishaDomain" to="/profile/addresses")
      span.tab-controls__item__title {{ $t('addresses') }}
      span.tab-controls__item__anchor
    //- router-link.tab-controls__item(v-if="isAfishaDomain" to="/profile/passports")
    //-   span.tab-controls__item__title {{ $t('passports') }}
    //-   span.tab-controls__item__anchor

  spacer(size="50px")

  transition(name="taber" mode="out-in")
    router-view

  //- div
    .tabs
      .tab(v-if="active==0")
        .tab__content
          .profile-info(v-if="profile")
            .preloader(v-if="loader")
            .row
              .col
                .label {{$t('common.name')}}
                input.input(v-model="profile.firstName")
            .row
              .col
                .label {{$t('common.lastName')}}
                input.input(v-model="profile.lastName")
            .row
              .col
                .label {{$t('common.middleName')}}
                input.input(v-model="profile.middleName")
            .row
              .col
                .label Пол
                select.input(v-model="profile.gender")
                  option(:value="1") Мужской
                  option(:value="0") Женский
            .row
              .col
                .label Дата рождения
            .row
              .col
                select.input(name="day", v-model="activeDob.day")
                  option(v-for="(day, index) in dates.days", :value="index") {{day}}
              .col
                select.input(name="mounth", v-model="activeDob.mounth")
                  option(v-for="(mounth, index) in dates.mounths", :value="index") {{mounth}}
              .col
                select.input(name="year", v-model="activeDob.year")
                  option(v-for="(year, index) in dates.years", :value="index") {{year}}
            .row
              .col
                .label Город
                select.input(name="city", v-model="profile.cityId")
                  option(v-for="city in cities", :value="city.id") {{city.name}}
            .row
              .col
                .label Email
                input.input(v-model="profile.email")
            .row
              .col
                .label
                  button.btn(@click="setProfileData()") Сохранить данные
      .tab(v-if="active==1")
        .tab__title Подписка
        .tab__content

</template>

<script>
import { mapGetters } from 'vuex';
import API from '@/api/api';
export default {
  data() {
    return {
      loader: true,
      active: 0,
      dates: null,
      profile: null,
      cities: null,
      activeDob: {
        day: null,
        mounth: null,
        year: null,
      },
      socials: null,
      valid: false,
      isAfishaDomain: true,
    };
  },
  mounted() {
    this.initDates();
    if (window.location.href.match(/localhost/) || window.location.href.match(/guru.ge/)) this.isAfishaDomain = false;
    // this.getCities();
    // this.getInfo();
  },
  computed: {
    ...mapGetters({
      isLogged: 'user/isLogged',
    }),
  },
  watch: {
    isLogged(val) {
      this.logged = val;
      if (this.logged) {
        this.getCities();
        this.getInfo();
      }
    },
  },
  methods: {
    initDates() {
      if (!this.dates) {
        this.dates = {
          days: [],
          mounths: [],
          years: [],
        };
      }
      for (let i = new Date().getFullYear() - 99; i <= new Date().getFullYear(); i += 1) {
        this.dates.years.push(String(i));
      }
      for (let i = 1; i < 32; i += 1) {
        this.dates.days.push(String(i));
      }
      this.dates.mounths = ['янв.', 'фев.', 'мар.', 'апр.', 'май.', 'июн.', 'июл.', 'авг.', 'сен.',
        'окт.', 'ноя.', 'дек.'];
    },

    async getInfo() {
      const data = await API.getUserInfo((error) => {
        // ERROR SCENARIUS
        console.error('Error', error);
      });
      if (data && data.id) {
        console.log(data);
        this.profile = data;
        this.getDob(data.dob);
        this.initSocials(data.socials);
        this.loader = false;
      }
    },

    async getCities() {
      const data = await API.getCities();
      if (data.data) {
        this.cities = data.data;
      }
    },

    getDob(date) {
      if (date) {
        const dob = date.split('-');
        setTimeout(() => {
          this.activeDob.day = parseFloat(dob[2]) - 1;
          this.activeDob.mounth = parseFloat(dob[1]) - 1;
          this.activeDob.year = this.dates.years.indexOf(dob[0]);
        }, 500);
      } else {
        this.activeDob = {
          day: 1,
          mounth: 0,
          year: String(new Date().getFullYear()),
        };
      }
    },

    initSocials(socials) {
      const defaultSocials = [
        { name: 'facebook' },
        // {name: 'vk'}
      ];
      this.socials = Object.assign([], defaultSocials, socials);
    },

    setProfileData() {
      this.validate();
      this.saveProfileData();
    },

    async saveProfileData() {
      this.loader = true;
      if (this.valid) {
        const data = await API.setProfile(this.setParamsProfile(), (error) => {
          global.alert(this.$t('msgs.savingError'));
          console.log('error', error);
        });
        if (data && data.id) {
          this.profile = this.getParamsProfile(data);
          this.loader = false;
          global.alert(this.$t('msgs.savingSuccess'));
          // const username = data.first_name.length ? data.firstName : data.phone;
          // const token = this.getCurrentUser.token;
          // const avatar = data.avatar;
          // const balance = data.balance;
          // this.$store.commit('user/setCurrentUser', { username, token, balance, avatar })
        }
      }
    },
    validate() {
      if (!this.profile.email.length) {
        this.valid = false;
        global.alert(this.$t('payment.email'));
      } else if (!this.profile.cityId) {
        this.valid = false;
        global.alert(this.$t('msgs.chsCity'));
      } else {
        this.valid = true;
      }
    },

    setDob() {
      return `${this.dates.years[this.activeDob.year]}-${this.setDobMounth(
        this.activeDob.mounth,
      )}-${this.dates.days[this.activeDob.day]}`;
    },

    setDobMounth(mounth) {
      mounth += 1;
      return mounth.length === 1 ? `0${mounth}` : mounth;
    },

    setParamsProfile() {
      return {
        email: this.profile.email,
        last_name: this.profile.lastName,
        first_name: this.profile.firstName,
        middle_name: this.profile.middleName,
        dob: this.setDob(),
        city_id: this.profile.cityId,
        gender: this.profile.gender,
        sms_subscribe: this.profile.smsSubscribe,
        email_subscribe: this.profile.emailSubscribe,
      };
    },

    getParamsProfile(data) {
      return {
        lastName: data.last_name,
        firstName: data.first_name,
        middleName: data.middle_name,
        email: data.email,
        dob: data.dob,
        cityId: data.city_id,
        gender: data.gender,
        smsSubscribe: data.sms_subscribe,
        emailSubscribe: data.email_subscribe,
      };
    },
  },
};
</script>

<style lang="scss">
.profile-info{
  position: relative;
  .preloader {
    height: 100%;
    width: 100%;
    position: absolute;
    background: #fff;
    opacity: .5;
  }
  .row{
    max-width: 400px;
    display: flex;
    .col{
      width: 100%;
      .label{
        font-size: 12px;
        font-weight: 600;
        padding-bottom: 1rem;
      }
      .input{
        width: 100%;
        padding-left: 1rem;
        height: 40px;
        font-size: 14px;
        margin-bottom: 1.5rem;
        border: 1px solid #ddd;
      }
      select{
        background: #fff;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        padding-left: 1rem;
        border-radius: 0;
      }
      & + .col{
        margin-left: 1rem;
      }
    }
    label{
      font-size: 12px;
      font-weight: 600;
    }
  }
}

.table-info {
  &__no-data {
    font-size: 18px;
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  &__item {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 20px;
    & + & {
      border-top: 1px solid #dedede;
    }
    transition: background-color .2s;
    &:hover {
      background-color: #f7f7f7;
    }
    .col:first-of-type {
      flex: 1;
    }
    .col > .row {
      flex-wrap: wrap;
      line-height: 150%;
    }
    .col > .row + .row {
      margin-top: 10px;
    }
    .button + .button {
      margin-left: 10px;
    }
    .comma {
      margin-right: 10px;
    }
    span > b {
      margin-left: 5px;
    }
  }
  &__list {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
  }
  &__footer {
    border-top: 1px solid #dedede;
    padding: 20px;
    display: flex;
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
